import React from 'react'
import { Box, Button, Typography, IconButton, CircularProgress, LinearProgress } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { CertificationIcon } from '../../icons'
import ValidationErrorText from '../common/ValidationErrorText'

const CertificationUpload = ({
  fileUrl = '',
  fileName = '',
  uploading = false,
  progress = 0,
  error = '',
  readOnly = false,
  onUpload,      // (file) => void
  onDelete,      // () => void
  fieldError,
  fieldErrors,
  fieldType
}) => {
  // Hidden file input handler
  const handleFileChange = (e) => {
    const file = e.target.files && e.target.files[0]
    if (!file) return

    // Allowed MIME types
    const allowedTypes = ["image/jpeg", "image/png", "image/webp", "image/jpg"];
    // Validate file type
    if (!allowedTypes.includes(file.type)) {
      alert("Only image files (jpg, jpeg, png, webp) are allowed.");
      return;
    }
    onUpload && onUpload(file)
    // Optionally, reset the input value so you can re-upload the same file if needed
    e.target.value = ''
  }

  return (
    <Box sx={{ mt: 4 }}>
      <Typography sx={{ fontWeight: 600, mb: 1 }}>Certification</Typography>
      <Box display="flex" alignItems="center" gap={2}>
        <Box
          sx={{
            width: 100,
            height: 100,
            border: '1px dashed #0463EF',
            borderRadius: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: readOnly
              ? 'not-allowed'
              : fileUrl
                ? 'default'
                : 'pointer',
            color: '#0463EF',
            background: '#F0F6FE',
            position: 'relative',
            overflow: 'hidden',
          }}
          onClick={() => {
            if (!readOnly && !fileUrl && !uploading) {
              document.getElementById('certification-file-input').click()
            }
          }}
        >
          {uploading ? (
            <Box width="100%" textAlign="center">
              <CircularProgress size={28} />
              <Typography fontSize="12px" mt={1}>
                {progress < 100 ? `${progress}%` : "Done"}
              </Typography>
              {progress > 0 && progress < 100 && (
                <Box mt={1}>
                  <LinearProgress variant="determinate" value={progress} sx={{ height: 6, borderRadius: 3 }} />
                </Box>
              )}
            </Box>
          ) : fileUrl ? (
            <>
              <img
                src={fileUrl}
                alt="Uploaded"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
              {!readOnly && (
                <IconButton
                  size="small"
                  onClick={e => {
                    e.stopPropagation()
                    onDelete && onDelete()
                  }}
                  sx={{
                    position: 'absolute',
                    top: 2,
                    right: 2,
                    backgroundColor: 'rgba(255,255,255,0.7)',
                  }}
                  disabled={uploading}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              )}
            </>
          ) : (
            <CertificationIcon />
          )}
        </Box>

        {/* Hidden file input */}
        <input
          id="certification-file-input"
          type="file"
          style={{ display: 'none' }}
          accept="image/*"
          onChange={handleFileChange}
          disabled={readOnly || uploading}
        />

        {/* Upload Button */}
        {/* {!fileUrl && !readOnly && (
          <Button
            variant="outlined"
            startIcon={<CertificationIcon />}
            onClick={() => document.getElementById('certification-file-input').click()}
            sx={{
              color: '#1075FF',
              border: '1px solid #1075FF',
              textTransform: 'capitalize',
              px: 3,
              mt: 1,
            }}
            disabled={uploading}
          >
            Upload Certification Here
          </Button>
        )} */}
      </Box>

      {error && <Typography color="error" mt={1}>{error}</Typography>}

      {/* Show file name below only if no image preview */}
      {!fileUrl && fileName && (
        <Typography sx={{ mt: 1 }}>{fileName}</Typography>
      )}
      <ValidationErrorText error={fieldErrors?.[`${fieldType}.certification`]}/>
      
    </Box>
  )
}

export default CertificationUpload
